import { Box, TextField } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledDiv = styled(Box)(({ theme }) => ({
  gap: theme.spacing(2),
  display: "flex",
  padding: "0px",
  flexDirection: "column",

  "& > div": {
    display: "flex",
    justifyContent: "space-evenly"
  },

  "& button": {
    borderRadius: ".625rem",
    fontSize: "0.75rem",
    padding: "0.554rem 0",
    width: "100%",
    fontWeight: 500,
    boxShadow: "none",
    backgroundColor: theme.palette.grey[100],
    color: "black",

    "&:hover": {
      boxShadow: "none",
      backgroundColor: (theme.palette as any).primary[300]
    },

    "&.primary": {
      backgroundColor: (theme.palette as any).primary[600],
      color: theme.palette.secondary.main
    }
  }
}))

export const StyledSearchTextfield = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    minWidth: 300,
    backgroundColor: (theme.palette as any).default[100],
    color: (theme.palette as any).default[600],
    borderRadius: 8,
    "& fieldset": {
      border: "none"
    },
    "&:hover fieldset": {
      border: `1px solid ${(theme.palette as any).secondary[600]}`
    },
    "&.Mui-focused fieldset": {
      border: `2px solid ${(theme.palette as any).secondary[600]}`
    },
    "&.Mui-focused:hover fieldset": {
      border: `2px solid ${(theme.palette as any).secondary[600]}`
    }
  }
}))
